export const yesNoFormatter = (b: boolean) => (b ? 'Yes' : 'No');
